import { render } from "./VODBucketPlayerSettings.vue?vue&type=template&id=5be4e945"
import script from "./VODBucketPlayerSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./VODBucketPlayerSettings.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/StreamsDash/VODBucketPlayerSettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5be4e945"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5be4e945', __exports__)) {
    api.reload('5be4e945', __exports__)
  }
  
  module.hot.accept("./VODBucketPlayerSettings.vue?vue&type=template&id=5be4e945", () => {
    api.rerender('5be4e945', render)
  })

}


export default __exports__